module.exports = __webpack_public_path__ + "static/media/Guaranteed.823098c8.svg";